import { FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { StoreState } from "../../redux/reducers";
import { apiUrl } from "../../config";

const TopNavBar: FC = () => {
  const authUsers = useSelector((state: StoreState) => state.authUser);

  return (
    <nav className="main-header navbar navbar-expand navbar-light fixed-top">
      <img
        src={apiUrl + "/" + authUsers.photoUrl}
        alt="User Logo"
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "50px",
          objectFit: "cover",
        }}
      />
      <span
        style={{
          fontFamily: "OfficinaSans-Bold",
          fontWeight: "bold",
          fontSize: "30px",
          color: "#10296C",
          marginLeft: "10px",
          textTransform: "uppercase",
        }}
      >
        {authUsers.name}
      </span>

      <ul className="navbar-nav ml-auto">
        {/* <li className="nav-item mt-2">
          <span
            className="px-3 py-1 rounded-pill d-flex align-items-center"
            style={{
              backgroundColor: "#10296C",
              color: "white",
              fontWeight: 600,
              textTransform: "uppercase",
              marginRight: "10px",
            }}
          >
            <i className="fas fa-user mr-2"></i>
            {authUsers.name}
          </span>

        </li> */}
        {/* <li className="nav-item">
          <Link to="/login" className="nav-link" role="button">
            <i className="fas fa-sign-in-alt" style={{ color: "#10296C" }}></i>
          </Link>
        </li> */}
        <li className="nav-item">
          <Link to="/logout" className="nav-link" role="button">
            <i className="fas fa-sign-out-alt" style={{ color: "#10296C" }}></i>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link"
            data-widget="pushmenu"
            to="#"
            role="button"
          >
            <i className="fas fa-bars" style={{ color: "#10296C" }}></i>
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i
              className="fas fa-expand-arrows-alt"
              style={{ color: "#10296C" }}
            ></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default TopNavBar;
